export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';

//Login
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

//Entity 
export const ENTITY_REQUEST = 'ENTITY_REQUEST';
export const ENTITY_SUCCESS = 'ENTITY_SUCCESS';
export const ENTITY_FAILURE = 'ENTITY_FAILURE';


//DESTINATION
export const DESTINATION_REQUEST = 'DESTINATION_REQUEST';
export const DESTINATION_SUCCESS = 'DESTINATION_SUCCESS';
export const DESTINATION_FAILURE = 'DESTINATION_FAILURE';

//DESTINATION CATEGORY
export const DESTINATION_CAT_REQUEST = 'DESTINATION_CAT_REQUEST';
export const DESTINATION_CAT_SUCCESS = 'DESTINATION_CAT_SUCCESS';
export const DESTINATION_CAT_FAILURE = 'DESTINATION_CAT_FAILURE';

//TICKET
export const TICKET_REQUEST = 'TICKET_REQUEST';
export const TICKET_SUCCESS = 'TICKET_SUCCESS';
export const TICKET_FAILURE = 'TICKET_FAILURE';


//DEACTIVATE DESTINATION BUTTON
export const DEACTIVATE_DESTINATION_REQUEST = 'DEACTIVATE_DESTINATION_REQUEST';
export const DEACTIVATE_DESTINATION_SUCCESS = 'DEACTIVATE_DESTINATION_SUCCESS';
export const DEACTIVATE_DESTINATION_FAILURE = 'DEACTIVATE_DESTINATION_FAILURE';

//DESTINATION BY ID
export const DESTINATION__BYID_REQUEST = 'DESTINATION__BYID_REQUEST';
export const DESTINATION__BYID_SUCCESS = 'DESTINATION__BYID_SUCCESS';
export const DESTINATION__BYID_FAILURE = 'DESTINATION__BYID_FAILURE';

//DESTINATION UPDATE
export const DESTINATION_UPDATE_REQUEST = 'DESTINATION_UPDATE_REQUEST';
export const DESTINATION_UPDATE_SUCCESS = 'DESTINATION_UPDATE_SUCCESS';
export const DESTINATION_UPDATE_FAILURE = 'DESTINATION_UPDATE_FAILURE';